import * as React from 'react';

/**
 * The {@link https://scm.bluebeam.com/projects/DEN/repos/den-reactapp/browse Argox - Web Client} application.
 * @remarks This constant is deliberately separate from where it will be rendered so that we only import the application once.
 */
export const ArgoxApp = React.lazy(() => import('argox/App'));
